<template>
    <div class="container system_list">
        <div class="fk-content-wide" style="border-radius:6px;font-family:'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;font-weight:600;user-select: none;">

            <div v-if="!isLoading" style="">

                <div style="font-size:42px;">
                    <div class="rubrik">Välj krisindikator att arbeta med</div>
                    <div class="iContainer_container" style="">
                        <div v-for="(item, index) in alla_indikatorer" @mouseup="goto_page(item.lankmal)" class="iContainer" v-bind:style="get_style(item.bildfil)" v-bind:id="item.namn"><div class="indikatorettikett">{{item.namn}}</div></div>
                    </div>
                </div>

                <div style="display:flex;position:absolute;bottom:70px;left:calc(50% - 186px);">
                    <div style="display:flex;justify-content:center;">
                        <div style="display:inline-block;justify-content:center;vertical-align:middle;">

                            <img src="static/images/HIS_SE_LOGO_WEB.png" alt="HIS" width="100" height="100">
                            <img src="static/images/sms.jpg" alt="SMS" width="100" height="92" style="margin-left:30px;margin-right:30px;">
                            <img src="static/images/falkoping.png" alt="FALKÖPING" width="143" height="33">

                        </div>
                    </div>
                </div>
            </div>

            <div v-else class="loader"></div>

        </div>
    </div>
</template>


<script>

    //import _ from "lodash";
    //import Alert from './Alert.vue';   
   

    export default {
        data() {
            return {
                // För att addera indikatorer:
                // Lägg till en kopia av en av raderna här under inom arrayen alla_indikatorer.
                // Ändra namn, bildfil och lankmal (länkmål) och lägg in en bildfil i mappen dist
                // Skapa en kopia av mallsida.vue och döp till ett lämpligt indikatornamn
                alla_indikatorer: [
                    { namn: "Frånvaro", bildfil: "franvaro.jpg", lankmal: "franvaro_meny" },
                    { namn: "Elförsörjning", bildfil: "elforsorjning.jpg", lankmal: "elforsorjning"  },
                    { namn: "Kollektivtrafik", bildfil: "trafik.jpg", lankmal: "trafik"  },
                ],
             
                isLoading: true,

            };
        },
        created: function () {

            this.isLoading = false; 

        },
        computed: {

        },
        mounted: function () {
            
        },
        watch: {
           
        },
        components: {
            //Alert
        },
        methods: {   

            // Här kopplar vi bildfilerna till div:arna som utgör valknappar
            get_style: function (_bildfil) {
                var return_style = { "background-image": "url('./static/images/" + _bildfil + "')", "background-size": "cover"};               
                return return_style
            },

            // Navigeringen sköts här efter klick på valknapparna
            goto_page: function (_namn) {
                console.log("Ska visa sida: " + _namn);
                this.$router.push({ path: '/' + _namn })
            }

        },
        
    };

   
</script>





<style scoped>

    /* Spinner */
    .loader {
        position: absolute;
        z-index: 100;
        border: 16px solid #f3f3f3;
        border-radius: 50%;
        border-top: 16px solid #2C588D;
        width: 100px;
        height: 100px;
        top: 50%;
        left: 50%;
        -webkit-animation: spin 2s linear infinite; /* Safari */
        animation: spin 2s linear infinite;
    }
    /* Safari */
    @-webkit-keyframes spin {
        0% {
            -webkit-transform: rotate(0deg);
        }

        100% {
            -webkit-transform: rotate(360deg);
        }
    }

    @keyframes spin {
        0% {
            transform: rotate(0deg);
        }

        100% {
            transform: rotate(360deg);
        }
    }
    /* Slut Spinner */
   


    .fk-content-wide {
        padding: 10px 10px 0 10px;
        margin: 15px 10px 12px 10px;
        background-color: transparent;
        overflow: hidden;       
    }

    .iContainer_container {
        display: flex;
        flex-direction: row;
        margin-top:30px;
        justify-content: center;
        height: 400px;
    }

    .iContainer {
        overflow: hidden;
        background-color: lightgreen;
        margin: 10px;
        padding: 5px;
        border-radius: 15px;
        width: 260px;
        height: 190px;
        border: 1px solid rgba(130,130,130,1);
        box-shadow: rgba(0,0,0,0.4) 5px 5px 6px;
        z-index: 1;
    }

        .iContainer:hover {
            transform: rotate(-3deg) scale(1.25);
            box-shadow: rgba(0,0,0,0.4) 10px 10px 10px;
            z-index: 100;
            transition: all 0.15s ease;
        }

    .indikatorettikett {        
        font-size:16px;
        text-align: center;
        position: relative;
        margin-top: 155px;
        background-color: rgba(255,255,255,0.8);
        border-radius: 0 0 10px 10px;
    }

    .rubrik {
        text-align: center;
        text-shadow: 2px 3px 3px rgba(0,0,0,0.3);
    }

    .container {
        overflow: hidden;
    }



</style>



// WEBPACK FOOTER //
// src/Startsida.vue